export async function insertAddressDetails(formData, id) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/save/address-details/${id}`;
  const rawResponse = await fetch(url, {
    method: "Post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(formData),
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}
